<template>
  <section class="hero is-light is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-4">
            <section class="box">
              <b-field label="Username">
                <p class="control has-icons-left">
                  <input type="text" class="input" v-model="state.username" />
                  <span class="icon is-left">
                    <svg>
                      <Icon :icon="mdiAccount"></Icon>
                    </svg>
                  </span>
                </p>
              </b-field>
              <b-field label="Password">
                <p class="control has-icons-left">
                  <input
                    type="password"
                    class="input"
                    v-model="state.password"
                  />
                  <span class="icon is-left">
                    <Icon :icon="mdiLock"></Icon>
                  </span>
                </p>
              </b-field>
              <b-field>
                <button class="button is-success" @click="onLogin">
                  Login
                </button>
              </b-field>
            </section>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { reactive } from "@vue/composition-api";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import Icon from "../components/Icon";
import { mdiAccount, mdiLock } from "@mdi/js";
import ui from "@/store/modules/ui";

export default {
  components: { Icon },
  setup(props, { root }) {
    const state = reactive({
      username: "",
      password: ""
    });

    const onLogin = async () => {
      try {
        await ui.signin({
          username: state.username,
          password: state.password
        });
        root.$router.push("/home");
      } catch (err) {
        console.error("Caught: " + err);
        Snackbar.open({
          message: err.message,
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      }
    };

    return {
      state,
      onLogin,
      mdiAccount,
      mdiLock
    };
  }
};
</script>
